/**
 * Naming convention for Action Types
 * Two type of actions- User Generated || System Generated
 * Respective prefixes- USER | SYSTEM
 *
 * For Var Names, Format to be followed (will need to keep evolving and add more formats)
 * USER_CLICKED_$item  (item can be quill, drawer button, feedback, copyALL and so on)
 * USER_CHANGED_$setting (setting can be mode, WF, lengthGauge, summaryMode and so on)
 *
 * SYSTEM_STARTED_$process (process can be abs_summarization, ext_summarization, article_paraphrasing, sentence_paraphrasing, feedback_submission)
 * SYSTEM_FINISHED_$process
 * SYSTEM_ERROR_$process
 *
 * SYSTEM_MESSAGE_ALERT
 * SYSTEM_MESSAGE_TOASTR
 *
 * For Values, format would be like-
 * $moduleName/$actor/$action_($process | $item | $setting)
 *
 * For Module Names, we can use abbrevations everywhere- (any cons on this??)
 * Suummarizer- smzr
 * Paraphraser- pphr
 * Citation Generator- ctgr
 * Ghost Writer- gtwr
 *
 * Common- comn
 *
 */
const modulePrefix = 'SUMMARIZER/';
export const FEEDBACK_OPENED = 'FEEDBACK_OPENED';

// shared Actions
export const COPY_ALL = `${modulePrefix}COPY_ALL`;

// USER_CLICKED actions
export const USER_CLICKED_COPY_ALL = 'smzr/user/clicked_copy_all';
export const USER_CLICKED_MODE_EXPANSION_PANEL = 'smzr/user/clicked_mobile_mode_expansion_panel';
export const USER_CLICKED_DELETE_TEXT = 'smzr/user/clicked_delete_text';
export const USER_CLICKED_UNDO_DELETE_TEXT = 'smzr/user/clicked_undo_delete_text';
export const USER_CLICKED_INSERT_TEXT = 'smzr/user/clicked_insert_into_doc';
export const USER_CLICKED_PARAPHRASE_SUMMARY = 'smzr/user/clicked_paraphrase_summary';
export const USER_CLICKED_KEYWORD = 'smzr/user/clicked_keyword';
export const USER_CLEARED_KEYWORDS = 'smzr/user/cleared_keywords';

//  USER_UPLOADED_ACTIONS
export const USER_UPLOADED_FILE = 'smzr/user/uploaded_file';
export const USER_PASTED_TEXT = 'smzr/user/pasted_text';

// USER_CHANGED actions
export const USER_CHANGED_MODE = 'smzr/user/changed_mode';
export const USER_CHANGED_LENGTH_GAUGE = 'smzr/user/changed_length_gauge';
export const USER_CHANGED_INPUT_TEXT = 'smzr/user/changed_input_text';
export const USER_CHANGED_ACTIVE_TAB = 'smzr/user/changed_mobile_active_tab';
export const CHAR_LIMIT_EXCEEDED = 'smzr/user/char_limit_exceeded';

// SYSTEM_action_process actions
export const SYSTEM_STARTED_SUMMARIZATION = 'smzr/system/started_summarization';
export const SYSTEM_FINISHED_SUMMARIZATION = 'smzr/system/finished_summarization';

export const SYSTEM_ERROR_SUMMARIZATION = 'smzr/system/error_summarization';
export const SYSTEM_SET_KEYWORDS = 'smzr/system/set_keywords';
export const LOADING_KEYWORDS = 'smzr/system/loading_keywords';
export const HYDRATE_STORE_FROM_SESSION = 'smzr/system/hydrate_store_from_session';

// SYSTEM_CONSTRAINT actions
export const SYSTEM_CONSTRAINT_CHAR_LIMIT = 'smzr/system/constraint_char_limit';
